module.exports = __webpack_public_path__ + "img/credit-card-master.b35621df.png";